import { takeEvery, put } from 'redux-saga/effects'
import types from './actionTypes'
import AuthAPI from '../../../api/auth'

function* processLogin({ data }) {
  try {
    const response = yield AuthAPI.loginWithToken(data.token)
    yield put({ type: types.AUTH_SHOW_AVAILABLE, data: response })
  } catch(e) {
    console.log(e)
    yield put({ type: types.AUTH_FAIL })
  }
}

function* loadLoginProfile({ data }) {
  try {
    const response = yield AuthAPI.loadLoginProfile(data.account.access_token)
    yield put({ type: types.AUTH_SELECT_ACCOUNT, data: {
      ...data,
      user: response
    }})
  }
  catch(e) {
    yield put({ type: types.AUTH_LOAD_PROFILE_ERROR })
  }
}

function* reloadProfile() {
  try {
    const response = yield AuthAPI.loadLoginProfile()
    yield put({ type: types.AUTH_REFRESH_PROFILE_COMPLETE, data: response })
  }
  catch(e) {
    console.log(e)
    yield put({ type: types.AUTH_LOAD_PROFILE_ERROR })
  }
}

function* authSaga() {
  yield takeEvery(types.AUTH_LOAD_LOGIN_PROFILE, loadLoginProfile)
  yield takeEvery(types.AUTH_LOGIN, processLogin)
  yield takeEvery(types.AUTH_REFRESH_PROFILE, reloadProfile)
}

export default authSaga



// WEBPACK FOOTER //
// ./src/containers/Auth/store/sagas.js